import Header from "@/components/Header";
import Footer from "@/components/Footer";
import NewHero from "@/components/home/NewHero";
import NewValueProps from "@/components/home/NewValueProps";
import NewServices from "@/components/home/NewServices";
import NewGallery from "@/components/home/NewGallery";
import NewProcess from "@/components/home/NewProcess";
import NewTestimonials from "@/components/home/NewTestimonials";
import NewFinalCTA from "@/components/home/NewFinalCTA";
import { Helmet } from "react-helmet-async";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Tera Seguridad C.A. | Sistemas de seguridad, control y redes para empresas</title>
        <meta 
          name="description" 
          content="Instalación y mantenimiento de videovigilancia, control de acceso y asistencia, redes, alarmas y telefonía para empresas. Diseño de ingeniería, optimización de recursos y cero sorpresas. Evaluación sin costo esta semana." 
        />
        <meta name="keywords" content="seguridad, videovigilancia, CCTV, control de acceso, control de asistencia, redes, alarmas, empresas, Venezuela, Caracas, La Guaira" />
        <link rel="canonical" href="https://teraseguridad.com" />
      </Helmet>

      <div className="min-h-screen">
        <Header />
        <main>
          <NewHero />
          <NewValueProps />
          <NewServices />
          <NewGallery />
          <NewProcess />
          <NewTestimonials />
          <NewFinalCTA />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;